/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";

export const NOMINAS_CONSULTA = `${API_BASE_SRC}/nominas/evaluar`;
export const MERLIN = `${API_BASE_SRC}/ventaTC/wp/normalizarDomicilio`;
export const SEARCH_ENCOTESA = `${API_BASE_SRC}/ventaTC/wp/normalizarDomicilioEncotesa`;
export const SOCIAL_NET = `${API_BASE_SRC}/ventaTC/wp/socialNet`;
export const CONFIRMAR = `${API_BASE_SRC}/nominas/contratar`;
export const ALTA_CLIENTE_CA = `${API_BASE_SRC}/nominas/altaClienteConCA`;
export const ALTA_CLIENTE_CGU = `${API_BASE_SRC}/nominas/altaClienteConCGU`;
export const ALTA_CLIENTE_CAJA_AHORRO = `${API_BASE_SRC}/nominas/altaClienteConCajaAhorro`;
export const CONSULTA_BD = `${API_BASE_SRC}/nominas/consultaBD`;
export const CONSULTA_ESCLIENTE = `${API_BASE_SRC}/nominas/esCliente`;
export const CONFIRMAR_DATA_NOCLIENTE = `${API_BASE_SRC}/nominas/enviarMailSucursal`;
export const CONFIRMAR_RENAPER = `${API_BASE_SRC}/ventaTC/wp/confirmarDatos`;
export const ENVIAR_SMS = `${API_BASE_SRC}/biometriaEnCA/wp/enviarSms`;
export const CONSULTA_DATOS_PERSONA = `${API_BASE_SRC}/ventaTC/wp/consultarDatosPersona`;
export const CONSULTAR_OFERTA = `${API_BASE_SRC}/ventaTC/wp/consultarOferta`;
export const CONSULTAR_CUENTA_CLIENTE_EMPRENDEDORES = `${API_BASE_SRC}/aperturaCA/wp/consultaDatosCuentaYCliente`;
export const CONSULTAR_DOMICILIO = `${API_BASE_SRC}/biometriaEnCA/wp/consultarDomicilio`;
export const VALIDAR_DOMICILIO = `${API_BASE_SRC}/biometriaEnCA/wp/validarDomicilio`;
export const PROCESAR_DOMICILIO = `${API_BASE_SRC}/biometriaEnCA/wp/procesarDomicilio`;
export const GRABAR_DOMICILIO = `${API_BASE_SRC}/biometriaEnCA/wp/grabarDomicilio`;
export const ENVIO_FRENTE_DNI = `${API_BASE_SRC}/vdigital/wp/attachObverse`;
export const ENVIO_REVERSO_DNI = `${API_BASE_SRC}/vdigital/wp/attachReverse`;
export const ENVIO_SELFIE = `${API_BASE_SRC}/vdigital/wp/attachSelfieAlive`;
export const ENVIO_SELFIE_ALIVE = `${API_BASE_SRC}/vdigital/wp/attachProofOfLife`;
export const CONFIRMACION = `${API_BASE_SRC}/ventaTC/wp/confirmarOferta`;
export const SIGN_CONTRACTS = `${API_BASE_SRC}/ventaTC/wp/firmarContratos`;
export const GET_CONTRACT = `${API_BASE_SRC}/ventaTC/wp/consultarContratos`;
export const PERSISTIR_NUEVO_PASO = `${API_BASE_SRC}/carroAbandonado/persistirNuevoPaso`;
export const GENERAR_OTP = `${API_BASE_SRC}/ventaTC/wp/generarOtp`;
export const VALIDAR_OTP = `${API_BASE_SRC}/ventaTC/wp/validarOtp`;
export const CREAR_USUARIO = `${API_BASE_SRC}/ventaTC/wp/usuarioYClave`;
export const TOKENIZAR_USER = `${API_BASE_SRC}/customer/tokenize`;
export const NORMALIZAR_NUMERO = `${API_BASE_SRC}/ventaTC/wp/normalizarTelefono`;

export const PDF_CARTA =
  "https://www.bbva.com.ar/content/dam/public-web/argentina/documents/Carta_Cuenta_Sueldo.pdf";
